module.exports = __webpack_public_path__ + "images/stickers/pete-happy@2x.4c29c93d67330f3e566d.png";